import React from "react";
import "./styles.scss";
import ChatInput from "./ChatInput";
import Messages from "./Messages";
import _ from "lodash";
import FullPageSpinner from "../../../FullPageSpinner";
import { isCurrentUser } from "../../../../api/sendbird";
import UserTag from "./../../shared/UserTag";

export default ({
  selectedChannel,
  messagesLister,
  onLoadMore,
  messages,
  refMessages,
  onSubmitMessage
}) => {
  if (_.isNull(messages) && selectedChannel) {
    onLoadMore();
  }
  const members =
    selectedChannel && selectedChannel.members.filter(a => !isCurrentUser(a));
  return _.isNull(messages) ? (
    _.isNull(selectedChannel) ? null : (
      <FullPageSpinner
        status={messagesLister && messagesLister.isLoading ? "Loading" : ""}
      />
    )
  ) : (
    <>
      <div className="inbox-header pl-3">
        {selectedChannel &&
          members.map((member, i) => (
            <UserTag
              key={member.userId}
              className={i === members.length - 1 ? "mr-3" : "mr-n3"}
              user={{
                id: member.memberId,
                username: member.nickname,
                slug: member.metaData && member.metaData.slug,
                profile_picture: { url: member.profileUrl }
              }}
            />
          ))}
      </div>
      <div id="chat">
        <Messages refMessages={refMessages} messages={messages} />
        {!members.length ? null : (
          <ChatInput onSubmitMessage={onSubmitMessage} />
        )}
      </div>
    </>
  );
};
